import { writable, derived } from "svelte/store";

const localStoreValue = getValuesFromLocalStorage();

export const TYPO3_STATUS = writable(localStoreValue.TYPO3);
export const NEOS_STATUS = writable(localStoreValue.Neos);
export const LOGIN_STATUS = derived([TYPO3_STATUS, NEOS_STATUS], ([$TYPO3_STATUS, $NEOS_STATUS]) => {
    // Possible login states
    // pending
    // failed
    // true
    // false

    if ($TYPO3_STATUS === "pending" || $NEOS_STATUS === "pending") {
        return "pending";
    }
    if ($TYPO3_STATUS === "failed" || $NEOS_STATUS === "failed") {
        return "failed";
    }
    if ($TYPO3_STATUS === true && $NEOS_STATUS === true) {
        return true;
    }
    return false;
});

function updateLocalStorage(system, status) {
    if (system !== "TYPO3" && system !== "Neos") {
        return;
    }

    localStoreValue[system] = status;
    window.localStorage.login = JSON.stringify(localStoreValue);
}

function getValuesFromLocalStorage() {
    let value = window.localStorage.login;
    if (!value) {
        return { Neos: false, TYPO3: false };
    }
    value = JSON.parse(value);
    return {
        Neos: value?.Neos === true || false,
        TYPO3: value?.TYPO3 === true || false,
    };
}

// Anytime the store changes, update the local storage value.
TYPO3_STATUS.subscribe((value) => updateLocalStorage("TYPO3", value));
NEOS_STATUS.subscribe((value) => updateLocalStorage("Neos", value));
